export function isMenuItemActive(url: string, path: string) {
  const rootPath = path.substring(1).includes('/')
    ? path.substring(0, path.substring(1).indexOf('/') + 1)
    : path;

  return rootPath === '/' ? url === '/' : url.startsWith(rootPath);
}
